import React from 'react';
import './index.scss';

interface FieldItemProps {
  title?: string | number | React.ReactNode;
  info?: string | number | React.ReactNode;
  value?: string | number | React.ReactNode;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  // 兼容旧的 API
  label?: string;
  show?: boolean;
}

const FieldItem = (props: FieldItemProps) => {
  const {
    title,
    info,
    value,
    color,
    className = '',
    style,
    label,
    show = true,
  } = props;

  // 兼容处理：优先使用新的 API，回退到旧的 API
  const displayTitle = title || label;
  const displayValue = value !== undefined ? value : info;

  if (!show) return null;

  // 判断是否为 ReactNode（非字符串和数字）
  const isReactNode =
    displayValue !== null &&
    displayValue !== undefined &&
    typeof displayValue !== 'string' &&
    typeof displayValue !== 'number';

  return (
    <span className={`field-item-box ${className}`} style={style}>
      {displayTitle && <span className="field-item-title">{displayTitle}</span>}
      <span
        className={`field-item-info ${isReactNode ? 'field-item-node' : ''}`}
        style={color && !isReactNode ? { color } : undefined}
      >
        {displayValue !== undefined && displayValue !== null
          ? displayValue
          : '--'}
      </span>
    </span>
  );
};

export default React.memo(FieldItem);
